import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';

import { closeHeaderCatalog, clearHeaderMenuDropdown, spriteIcon } from '../../tools/functions';

export const HeaderPersonalMenu = {
    computed: {
        ...mapState(vplSiteStore, ['menu', 'IS_AUTHORIZED'])
    },
    mounted(){

    },
    methods: {
        spriteIcon,
        personalClick(e){

            if(!this.IS_AUTHORIZED){
                e.preventDefault();
                e.stopPropagation();
                $('#entrance').modal();
            }
        },
        linkEnter(e){
            closeHeaderCatalog();
            $('.js-catalog').removeClass('is-active');
            $('.js-header').find('.js-catalog-dropdown').removeClass('is-open');
            let link = $(e.target);
            if (!link.hasClass('is-open') && link.closest('.js-header-action-item').hasClass('has-child')) {
                link.addClass('is-open');
                link.closest('.js-header-action-item').find('.js-header-action-item-link-dropdown').addClass('is-show');
            }
        },
        linkLeave(){
            clearHeaderMenuDropdown();
        },
        dropdownEnter(e){

            $(e.target)
                .addClass('is-show')
                .parent('.js-header-action-item').find('.js-header-action-item-link').addClass('is-open');
        },
        dropdownLeave(){
            clearHeaderMenuDropdown();
        }
    },
    template: `
        <template v-if="this.menu.personal">
            <div v-if="this.IS_AUTHORIZED" v-for="menuItem in this.menu.personal.ITEMS" class="header__top-lk js-header-action-item has-child">
                <a :href="menuItem.LINK" @click="personalClick($event)" class="header__top-actions-link header__top-actions-link--lk js-header-action-item-link" @mouseenter="this.linkEnter($event)" @mouseleave="linkLeave()">

                    {{menuItem.TEXT}}
                </a>
                <div v-if="menuItem.CHILDS && Object.keys(menuItem.CHILDS).length" class="header__top-lk-dropdown js-header-action-item-link-dropdown" @mouseenter="this.dropdownEnter($event)" @mouseleave="this.dropdownLeave()">

                    <a v-for="childItem in menuItem.CHILDS" :href="childItem.LINK" class="header__top-lk-dropdown-item">
                        <div v-if="childItem.PARAMS.ICON" class="header__top-lk-dropdown-item-icon">
                            <svg v-if="spriteIcon(childItem.PARAMS.ICON)" class="ico" :class="['ico-' + spriteIcon(childItem.PARAMS.ICON), { 'ico-solo': !childItem.PARAMS.ICON_H }]" width="26" height="27" aria-hidden="true"><use :xlink:href="'#ico-' + spriteIcon(childItem.PARAMS.ICON)"></use></svg>
                            <svg v-if="spriteIcon(childItem.PARAMS.ICON) && childItem.PARAMS.ICON_H" class="ico hover" :class="'ico-' + spriteIcon(childItem.PARAMS.ICON_H)" width="26" height="27" aria-hidden="true"><use :xlink:href="'#ico-' + spriteIcon(childItem.PARAMS.ICON_H)"></use></svg>
                            <template v-if="!spriteIcon(childItem.PARAMS.ICON)">
                            <img :src="childItem.PARAMS.ICON" :alt="childItem.TEXT" :title="childItem.TEXT">
                            <img v-if="childItem.PARAMS.ICON_H" :src="childItem.PARAMS.ICON_H" class="hover" :alt="childItem.TEXT" :title="childItem.TEXT">
                            </template>
                        </div>
                        {{childItem.TEXT}}
                    </a>

                </div>
            </div>
            <div v-else v-for="menuItem in this.menu.personal.ITEMS" class="header__top-lk js-header-action-item has-child">
                <a :href="menuItem.LINK" @click="personalClick($event)" class="header__top-actions-link header__top-actions-link--lk js-header-action-item-link">
                    {{menuItem.TEXT}}
                </a>
            </div>
        </template>
    `
}